"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Text_1 = require("./Text");
function withTextStyle(props, textStyle) {
    return __assign({ textStyle: textStyle }, props);
}
function createShorcutComponent(textStyle) {
    return function (props) { return React.createElement(Text_1.default, withTextStyle(props, textStyle)); };
}
/* tslint:disable:variable-name */
exports.Display4 = createShorcutComponent("display4");
exports.Display3 = createShorcutComponent("display3");
exports.Display2 = createShorcutComponent("display2");
exports.Display1 = createShorcutComponent("display1");
exports.Headline = createShorcutComponent("headline");
exports.Title = createShorcutComponent("title");
exports.Subheading2 = createShorcutComponent("subheading2");
exports.Subheading1 = createShorcutComponent("subheading1");
exports.Body2 = createShorcutComponent("body2");
exports.Body1 = createShorcutComponent("body1");
exports.Caption = createShorcutComponent("caption");
/* tslint:enable:variable-name */
//# sourceMappingURL=shortcuts.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/typography/lib/shortcuts.js
// module id = ./node_modules/@react-mdc/typography/lib/shortcuts.js
// module chunks = 1 2 3